import React, { PropsWithChildren } from 'react';
import { ReactComponent as CheckCircle } from '../images/check_circle.svg';
import Modal from '@gr-monorepo/common/ui/Modal';

import { TextModalWrap } from './styled';

const SuccessModal = (props: PropsWithChildren<{ onClose: () => void }>) => {
  return (
    <Modal onClose={props.onClose} >
      <div style={{width: '832px'}}>
      <CheckCircle />
      <TextModalWrap>{props.children}</TextModalWrap>
      </div>
    </Modal>
  );
};

export default SuccessModal;
